var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pay-bill-item',{key:_vm.type,attrs:{"type":_vm.type},on:{"tab":_vm.onTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }